import { Suspense } from "preact/compat";
import { Navigate, Outlet, useLocation } from "react-router";
import { categories } from "@/data/categories.js";
import { overlays } from "@/data/overlays.jsx";
import { getTypeSlug } from "@/util/common.js";
import CustomizePageLayout from "./customize.page-layout.jsx";

export default function OverlayPageLayout() {
  const location = useLocation();
  const { slug, type } = getTypeSlug(location.pathname);

  const overlayInfo = overlays[slug];

  if (overlayInfo === undefined) {
    return <Navigate to={`/${type}`} replace={true} />;
  }

  const { name, pageName } = categories.find((category) => category.type === type);

  const parents = [{ title: pageName || name, href: `/${type}` }];

  return (
    <CustomizePageLayout {...overlayInfo} parents={parents}>
      <Suspense fallback={null}>
        <Outlet />
      </Suspense>
    </CustomizePageLayout>
  );
}
